"use strict";
(function () {
  if (!customElements.get("youtube-video")) {
    class YoutubeVideo extends HTMLElement {
      constructor() {
        super();
        this.player = null;
        this.isPlaying = false;
        this.isMuted = this.dataset.muted !== "false";
        this.isPlayerCreated = false;
        this.autoplay = this.hasAttribute("data-autoplay");
        this.videoId = this.dataset.videoId;
        this.playerId =
          "yt-player-" +
          this.dataset.videoId +
          "-" +
          Math.random().toString(36).slice(2, 7);

        this.onPlayerReady = this.onPlayerReady.bind(this);
        this.onPlayerStateChange = this.onPlayerStateChange.bind(this);
        this.onPauseBtnClick = this.onPauseBtnClick.bind(this);
        this.onMuteBtnClick = this.onMuteBtnClick.bind(this);
        this.elements = {
          pauseBtn: null,
          muteBtn: null,
          iframeContainer: null,
        };
      }

      connectedCallback() {
        this.setupElements();
        this.bindEvents();

        if (this.autoplay) {
          this.createPlayer();
        }
      }

      disconnectedCallback() {
        const { pauseBtn, muteBtn } = this.elements;
        if (pauseBtn) pauseBtn.removeEventListener("click", this.onPauseBtnClick);
        if (muteBtn) muteBtn.removeEventListener("click", this.onMuteBtnClick);

        if (this.player && typeof this.player.destroy === "function") {
          this.player.destroy();
        }
      }

      setupElements() {
        this.elements.pauseBtn = this.querySelector(
          '[data-component="pause-btn"]',
        );
        this.elements.muteBtn = this.querySelector(
          '[data-component="mute-btn"]',
        );
        this.elements.iframeContainer = this.querySelector(
          '[data-component="iframe-container"]',
        );
      }

      bindEvents() {
        const { pauseBtn, muteBtn } = this.elements;

        if (pauseBtn) {
          pauseBtn.classList.add("active");
          pauseBtn.addEventListener("click", this.onPauseBtnClick);
        }
        if (muteBtn) {
          if (!this.isMuted) muteBtn.classList.add("active");
          muteBtn.addEventListener("click", this.onMuteBtnClick);
        }
      }

      createPlayer() {
        if (this.isPlayerCreated) return;
        this.isPlayerCreated = true;

        const container = this.elements.iframeContainer;
        if (!container) return;

        container.id = this.playerId;

        this.player = new YT.Player(this.playerId, {
          height: "360",
          width: "640",
          videoId: this.videoId,
          playerVars: {
            autoplay: 1,
            modestbranding: 1,
            controls: 0,
            disablekb: 1,
            iv_load_policy: 3,
            disablepictureinpicture: 1,
            mute: this.isMuted ? 1 : 0,
            loop: 1,
            playsinline: 1,
            rel: 0,
          },
          events: {
            onReady: this.onPlayerReady,
            onStateChange: this.onPlayerStateChange,
          },
        });
      }

      onPlayerReady() {
        this.player.playVideo();
        this.classList.add("loaded");
      }

      onPlayerStateChange(event) {
        const { pauseBtn } = this.elements;

        if (event.data === YT.PlayerState.PLAYING) {
          this.isPlaying = true;
          this.classList.add("loaded");
          if (pauseBtn) pauseBtn.classList.remove("active");
        } else if (
          event.data === YT.PlayerState.PAUSED ||
          event.data === YT.PlayerState.ENDED
        ) {
          this.isPlaying = false;
          this.classList.remove("loaded");
          if (pauseBtn) pauseBtn.classList.add("active");
        }
      }

      onPauseBtnClick() {
        if (!this.isPlayerCreated) {
          this.createPlayer();
          return;
        }

        const { pauseBtn } = this.elements;

        if (this.isPlaying) {
          this.player.pauseVideo();
          this.classList.remove("loaded");
          pauseBtn.classList.add("active");
          this.isPlaying = false;
        } else {
          this.player.playVideo();
          this.classList.add("loaded");
          pauseBtn.classList.remove("active");
          this.isPlaying = true;
          if (this.isMuted) {
            this.player.mute();
          }
        }
      }

      onMuteBtnClick() {
        const { muteBtn } = this.elements;

        if (this.isMuted) {
          this.player.unMute();
          muteBtn.classList.add("active");
          this.isMuted = false;
        } else {
          this.player.mute();
          muteBtn.classList.remove("active");
          this.isMuted = true;
        }
      }
    }

    customElements.define("youtube-video", YoutubeVideo);
  }
})();
